import { useApolloClient } from "@apollo/client";
import Formsy from "formsy-react";
import { useEffect, useMemo, useState } from "react";
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from "react-accessible-accordion";
import { useDispatch } from "react-redux";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { executeGraphQLMutation } from "../../../common/executeGraphQLQuery";
import { FIELDS_TO_DISABLE_IF_EXIST, getKeysData, isNeedsToDisable } from "../../../config/constants";
import GeneralService from '../../../services/generalService';
import { getLoanDetail } from "../../../store/action/allAction";
import acceptImg from "../../../webroot/images/acceptImg.svg";
import successImg from "../../../webroot/images/successImg.svg";
import FormsyDatePicker from "../../elements/FormsyDatePicker";
import FormsyInputField from "../../elements/FormsyInputField";
import FormsyTextAreaAutosize from "../../elements/FormsyTextAreaAutosize";
import Modal from "../../elements/Modal";
import VehicleDetailAndSoftCreditJson from '../formFields/vehicleDetailAndSoftCredit.json';
import { generateMutationAndVariables } from "../soft-approval/VehicleDetailAndSoftCredit.helper";
const current_page_fields = VehicleDetailAndSoftCreditJson.credit_advice_received || [];
const contract_info_field = VehicleDetailAndSoftCreditJson.credit_advice_received?.contract_info_field;
const { CREDIT_ADVICE_RECEIVED } = FIELDS_TO_DISABLE_IF_EXIST;

const CreditAdviceReceived = ({ props,
    setAllowSubmit,
    current_page, form_read_only, markAsFreezed, isValidDateSubmit, allowSubmit, isValidFileSubmit, isFileUploaded, accessCondition, showModalViewTimeLine, remarksHistory,
    leadDetail, financierKeyVal, creditAdviceReceived, setCreditAdviceReceived, user_id, setIsLoading
}) => {
    const [formFields, setFormFields] = useState({});
    const [frezeeCreditAdvicePopUp, setFrezeeCreditAdvicePopUp] = useState(false);
    const getContext = useOutletContext();
    const client = useApolloClient();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const [financierToFreeze, setFinancierToFreeze] = useState(0);
    const documentCategoryList = (getContext && getContext.docList) || [];

    useEffect(() => {
        const docMaster = documentCategoryList?.find(({ id }) => [95]?.includes(id))?.child || [];
        const requiredKeyVal = current_page_fields?.upload_docs?.reduce((result, doc) => { result[doc.doc_id] = doc; return result; }, {}) || {};
        const data = leadDetail?.soft_approval_ci_data?.reduce((result, financier) => {
            let docMasterData = docMaster?.map((doc) => {
                requiredKeyVal[doc.id] && (doc.is_required = requiredKeyVal[doc.id].required ? "1" : "0");
                doc.lead_doc_count = leadDetail?.leaddocs?.filter(({ doc_id, financier_id }) => doc_id === doc?.id && financier_id === financier?.financier_id)?.length || 0;
                return doc;
            }) || [];
            result[financier?.financier_id] = {
                ...financier,
                docMaster: JSON.parse(JSON.stringify(docMasterData)) || docMasterData
            };
            return result;
        }, {}) || {};
        setCreditAdviceReceived({ ...data });
    }, [leadDetail, documentCategoryList, current_page_fields]);
    
    useEffect(() => {
        Object.keys(creditAdviceReceived || {})?.forEach((financier_id) => {
            formFields[financier_id] = current_page_fields;
        });
        
        setFormFields({ ...formFields });
    }, [creditAdviceReceived, current_page_fields]);

    const isSaveNextDisabled = useMemo(() => {
        const isDateInvalid = current_page === "credit_advice_received" ? !isValidDateSubmit : !allowSubmit;
        const isFileInvalid = ["credit_advice_received", "orcr_received", "orcr_sent_for_title_transfer", "orcr_received_after_title_transfer"].includes(current_page)
            ? !isValidFileSubmit
            : !isFileUploaded;
      
        return form_read_only || isDateInvalid || isFileInvalid || markAsFreezed || accessCondition;
    }, [
        form_read_only,
        current_page,
        isValidDateSubmit,
        allowSubmit,
        isValidFileSubmit,
        isFileUploaded,
        markAsFreezed,
        accessCondition
    ]);

    const propsToPass = {
        setAllowSubmit, form_read_only, markAsFreezed,
        leadDetail, creditAdviceReceived, setCreditAdviceReceived, user_id, setIsLoading, client, dispatch, navigate
    };

    const frezeeCreditAdviceReceived = async () => {
        const lead_id = (leadDetail?.id && Number(leadDetail?.id)) || 0;
        setIsLoading(true);
        let commonFields = {
            lead_id,
            financier_id: financierToFreeze
        };
        const { variables, mutation, redirecturl } = generateMutationAndVariables({ current_page: "frezeeCreditAdviceReceived", commonFields, params });
        try {
            await executeGraphQLMutation(mutation, variables, client);
            dispatch(getLoanDetail(lead_id, client));
            toast.success("Success");
            setIsLoading(false);
            if (redirecturl) {
                navigate(redirecturl);
            }
        } catch (error) {
            setIsLoading(false);
            toast.error(error.toString().replace('ApolloError:', ''));
            console.error(error);
        }
            
    };
      
    return <div className={" switch-toggle"}>
        <div className="lead-form-heading">
            <h2>{props.name}</h2>
        </div>
        <Accordion allowZeroExpanded allowMultipleExpanded="true" >
            {leadDetail?.soft_approval_ci_data?.filter(({ is_credit_investigation_received }) => is_credit_investigation_received === "yes")?.map((financier) => {
                return <div className="">
                    <AccordionItem className='acc-item-financer'>
                        <AccordionItemHeading className='acc-heading-financer'>
                            <AccordionItemButton>
                                <div className='financer-name-no-date financer-name-date financer-name-no-date'>
                                    <img alt=''
                                        className="check-uncheck-img"
                                        onClick={() => { !leadDetail?.lead_details?.frezee_credit_advice_received && setFinancierToFreeze(financierToFreeze === financier?.financier_id ? 0 : financier?.financier_id); }}
                                        src={
                                            ((leadDetail?.lead_details?.frezee_credit_advice_received && financierKeyVal?.[financier?.financier_id]?.is_proceed === "yes" && financier?.is_credit_advice_received) || financier?.financier_id === financierToFreeze) ? acceptImg
                                                : financier?.is_credit_advice_received ? successImg
                                                    : ""}
                                    />
                                    <h3 title={financierKeyVal?.[financier?.financier_id].financier_name}>  {financierKeyVal?.[financier?.financier_id].financier_name}</h3>
                                    {/* {tab.org_custom_soft_approval_received && <span className='date-time-txt'>{dateFormat(tab.org_custom_soft_approval_received, 'd mmm,yyyy, h:MM:ss TT')}</span>} */}
                                </div>
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel className='acc-panel-finaner'>
                            <CreditAdviceReceivedFin
                                {...propsToPass}
                                vehicleAndSoftCreditDataExisted={financier}
                                vehicleAndSoftCreditData={creditAdviceReceived?.[financier?.financier_id]}
                            />
                        </AccordionItemPanel>
                    </AccordionItem>
                </div>;
            
            })}
        </Accordion>
        <div className="btn-save-remarks">
            {isSaveNextDisabled || leadDetail?.lead_details?.frezee_credit_advice_received || !financierToFreeze ? <span className="span-disabled">Next</span> : <button type="submit" className="btn-primary" disabled={isSaveNextDisabled} onClick={() => setFrezeeCreditAdvicePopUp(!frezeeCreditAdvicePopUp)}>Next</button>}
            <button type="button" className="btn-line" onClick={showModalViewTimeLine}>
                Remarks <span className="m-xs-l">({remarksHistory?.length || 0})</span>
            </button>
        </div>


        <div className="view-timeline-popup">
            <div className="view-timeline-popup">
                <Modal show={frezeeCreditAdvicePopUp} handleClose={() => setFrezeeCreditAdvicePopUp(!frezeeCreditAdvicePopUp)} >
                    <div className="modal-header">
                        <h2>Conformation ?</h2>
                    </div>
                    <div>
                        <h4>Are you sure you want to move ahead with this financier for contract signing? This action cannot be reverted.</h4>
                    </div><br />
                    <button type="submit" className="btn-primary" onClick={() => frezeeCreditAdviceReceived()}>Next</button>
                </Modal>
            </div>
        </div>
    </div>;
};

export default CreditAdviceReceived;
const CreditAdviceReceivedFin = ({
    setAllowSubmit, vehicleAndSoftCreditData, vehicleAndSoftCreditDataExisted, form_read_only, markAsFreezed,
    leadDetail, creditAdviceReceived, setCreditAdviceReceived, user_id, setIsLoading, client, dispatch, navigate
}) => {
    const [currentpagefields, setCurrentpagefields] = useState(current_page_fields ? JSON.parse(JSON.stringify(current_page_fields)) : []);
    const [expectedContractSignedDateSaved, setExpectedContractSignedDateSaved] = useState(false);

    const freezeCreditAdviceReceived = useMemo(() => {
        return false;
    }, [leadDetail]);
    const isValidDateSubmit = useMemo(() => {
        const fields = current_page_fields ? JSON.parse(JSON.stringify(current_page_fields)) : [];
        const docsPresent = vehicleAndSoftCreditData?.docMaster?.reduce((result, { id, lead_doc_count }) => { if (lead_doc_count) result.push(id); return result; }, []) || [];
        fields?.form_fields?.map(field => {
            if (["custom_credit_advice_received_date"].includes(field?.name) && vehicleAndSoftCreditData?.pre_approval_received_date) {
                field.required = false;
            }
            else if (["pre_approval_received_date"].includes(field?.name) && vehicleAndSoftCreditData?.custom_credit_advice_received_date) {
                field.required = false;
            }
            return field;
        });
        vehicleAndSoftCreditData?.docMaster?.map(doc => {
            if ([96, 136].includes(doc?.id)) {
                if (doc?.id === 96 && docsPresent.includes(136) && !docsPresent.includes(96)) doc.is_required = "0";
                if (doc?.id === 136 && docsPresent.includes(96) && !docsPresent.includes(136)) doc.is_required = "0";
            }
            return doc;
        });

        setCurrentpagefields(fields);
        const isDocPresents = vehicleAndSoftCreditData?.docMaster?.filter(({ is_required }) => is_required === "1")?.every(({ min_upload, lead_doc_count }) => lead_doc_count >= min_upload);
        return ((vehicleAndSoftCreditData?.custom_credit_advice_received_date || vehicleAndSoftCreditData?.pre_approval_received_date) && isDocPresents) ? false : true;
    }, [vehicleAndSoftCreditData?.custom_credit_advice_received_date, vehicleAndSoftCreditData?.pre_approval_received_date, vehicleAndSoftCreditData?.docMaster, creditAdviceReceived]);
    const handleInputChange = (target_name, field_type, event, financier_id = 0) => {
        if (event) {
            let lead_detail_data = { ...creditAdviceReceived };
            lead_detail_data[financier_id][target_name] = field_type === "date-picker" ? new Date(event)?.toISOString() : event.target.value;
            setCreditAdviceReceived({ ...lead_detail_data });
        }
    };
    const handleExpectedContractSignedDateChange = (event) => {
        setExpectedContractSignedDateSaved(false);
        handleInputChange(contract_info_field?.name, contract_info_field?.type, event, vehicleAndSoftCreditData?.financier_id);
    };
    const saveExpectedContractSignedDate = async () => {
        const lead_id = (leadDetail?.id && Number(leadDetail?.id)) || 0;
        setIsLoading(true);
        let commonFields = {
            lead_id,
            user_id,
            financier_id: vehicleAndSoftCreditData?.financier_id,
            expected_contract_signed_date: vehicleAndSoftCreditData?.[contract_info_field?.name]
        };
        const { variables, mutation } = generateMutationAndVariables({ current_page: "saveExpectedContractSignedDate", commonFields });
        try {
            await executeGraphQLMutation(mutation, variables, client);
            dispatch(getLoanDetail(lead_id, client));
            toast.success("Success");
            setExpectedContractSignedDateSaved(true);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            toast.error(error.toString().replace('ApolloError:', ''));
            console.error(error);
        }
    };
    const handleFileChange = async (event, doc_id, parent_id, max_upload, lead_doc_count, financier_id) => {
        let selectedImage = event?.target?.files?.[0]?.name || "";
        let publicUrl = '', doc_path = '';
        if (!selectedImage) {
            toast.error("Please upload an image.");
            return;
        }
        setIsLoading(true);
        if ((max_upload - lead_doc_count) > 0) {
            const formData = new FormData();
            formData.append('upload_type', 'finance_docs');
            formData.append('lead_id', leadDetail?.id || leadDetail?.lead_id || 0);
            formData.append('images', event.target.files[0]);

            try {
                publicUrl = await GeneralService.uploadFilesToS3(formData, { 'Content-Type': 'multipart/form-data' });
                doc_path = publicUrl && publicUrl.data && publicUrl.data.data && publicUrl.data.data.length && (publicUrl.data.data[0].file_url || '');
                if (doc_path) {
                    const data = { ...creditAdviceReceived };
                    if (!data?.[financier_id]?.credit_document_docs?.length) data[financier_id].credit_document_docs = [];
                    data[financier_id].credit_document_docs?.push({ lead_id: leadDetail?.id || leadDetail?.lead_id || 0, doc_id, parent_doc_id: parent_id, financier_id, doc_path, doc_status: "2", doc_source: "web", status: "1", user_id });
                    data[financier_id].docMaster.find(({ id }) => id === doc_id).lead_doc_count++;
                    setCreditAdviceReceived({ ...data });
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
            }
        }
    };
    const saveFormDetails = async () => {
        const lead_id = (leadDetail?.id && Number(leadDetail?.id)) || 0;
        setIsLoading(true);
        
        let commonFields = {
            lead_id,
            user_id,
            ...getKeysData(vehicleAndSoftCreditData, ["credit_advice_reference_number", "custom_credit_advice_received_date", "pre_approval_received_date", "credit_advice_reference_notes", "financier_id", "credit_document_docs", "expected_contract_signed_date"])
        };
        const { variables, mutation, redirecturl } = generateMutationAndVariables({ current_page: "saveCreditAdviceReceived", commonFields });
        try {
            await executeGraphQLMutation(mutation, variables, client);
            dispatch(getLoanDetail(lead_id, client));
            toast.success("Success");
            setIsLoading(false);
            if (redirecturl) {
                navigate(redirecturl);
            }
        } catch (error) {
            setIsLoading(false);
            toast.error(error.toString().replace('ApolloError:', ''));
            console.error(error);
        }
            
    };
    const isSaveExpectedDateDisabled = !vehicleAndSoftCreditData?.[contract_info_field?.name] || form_read_only || markAsFreezed;
    return <div className="soft-approvel-sec padding-16">
        <Formsy className="lead-form-filed" autoComplete="off">
            <div className="row contract-info-box" style={{ background: "#f5f6f8", borderRadius: 8, padding: 16, marginBottom: 16 }}>
                <div className="col-md-12">
                    <h4><b>Contract Information</b></h4>
                    <p>Use this field if the contract is signed but the Credit Advice document has not yet been received.</p>
                </div>
                <div className="col-md-12" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', paddingTop: 20 }}>
                    <fieldset className="form-filed col-md-8" style={{ margin: 0 }}>
                        <div className="material date-filed">
                            <FormsyDatePicker
                                name={contract_info_field?.name}
                                selectedDate={vehicleAndSoftCreditData && vehicleAndSoftCreditData[contract_info_field?.name] && new Date(vehicleAndSoftCreditData[contract_info_field?.name])}
                                value={(vehicleAndSoftCreditData && vehicleAndSoftCreditData[contract_info_field?.name] && Date.parse(vehicleAndSoftCreditData[contract_info_field?.name])) || ''}
                                placeholder={contract_info_field?.label}
                                onDateSelect={(e) => !form_read_only ? handleExpectedContractSignedDateChange(e) : e.preventDefault()}
                                dateFormat="dd MMM, yyyy h:mm aa"
                                showTimeSelect={true}
                                required={false}
                                readOnly={form_read_only || markAsFreezed || expectedContractSignedDateSaved}
                                col={"col-md-12"} />
                        </div>
                    </fieldset>
                    {!form_read_only && (
                        <div className="col-md-4 contract-info-save" style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                            {expectedContractSignedDateSaved ? (
                                <span className="saved-tick-lg"><i className="sprite ic-check"></i></span>
                            ) : (
                                isSaveExpectedDateDisabled ? <span className="span-disabled">Save date</span> :
                                    <button type="button" className="btn-primary" onClick={saveExpectedContractSignedDate}>Save date</button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Formsy>
        <Formsy
            className="lead-form-filed"
            autoComplete="off"
            onValid={() => setAllowSubmit(true)}
            onInvalid={() => setAllowSubmit(false)}
            onValidSubmit={saveFormDetails}
        >
            <div className="row">
                {currentpagefields?.form_fields.map((field) => (
                    ["text", "pattern-format"].includes(field.type) ? (
                        <fieldset className="form-filed col-md-12 ">
                            <div className="material">
                                <FormsyInputField
                                    id={field.id}
                                    name={field.name}
                                    type={field.type}
                                    value={vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name]}
                                    placeholder=" "
                                    label={field.label}
                                    onChange={e => handleInputChange(field.name, field.type, e, vehicleAndSoftCreditData?.financier_id)}
                                    format={field.ApplyNumberformat ? field.format : ""}
                                    required={field.required}
                                    readOnly={freezeCreditAdviceReceived || isNeedsToDisable(field?.name, CREDIT_ADVICE_RECEIVED, vehicleAndSoftCreditDataExisted?.[field?.name]) || field.readOnly}
                                    col={"col-md-12"} />
                            </div>
                        </fieldset>
                    ) :
                        field.type === "date-picker" ? (
                            <fieldset className="form-filed col-md-12">
                                <div className="material date-filed">
                                    <FormsyDatePicker
                                        name={field.name}
                                        selectedDate={vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name] && new Date(vehicleAndSoftCreditData[field.name])}
                                        value={(vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name] && Date.parse(vehicleAndSoftCreditData[field.name])) || ''}
                                        placeholder={field.label}
                                        onDateSelect={(e) => !form_read_only ? handleInputChange(field.name, field.type, e, vehicleAndSoftCreditData?.financier_id) : e.preventDefault()}
                                        dateFormat="dd MMM, yyyy h:mm aa"
                                        showTimeSelect={true}
                                        validations={field.validations}
                                        validationError={current_page_fields[field.name] ? field.validationError : ""}
                                        required={field.required}
                                        hasError={(current_page_fields.hasOwnProperty(field.name) && !current_page_fields[field.name]) ? true : false}
                                        readOnly={freezeCreditAdviceReceived || isNeedsToDisable(field?.name, CREDIT_ADVICE_RECEIVED, vehicleAndSoftCreditDataExisted?.[field?.name]) || field.readOnly || form_read_only}
                                        onBlur={(e) => console.log(e)}
                                        col={"col-md-12"} />
                                </div>
                            </fieldset>
                        ) :
                            field.type === "textarea" ? (
                                <fieldset className="form-filed text-area-filed col-md-12">
                                    <div className="material">
                                        <FormsyTextAreaAutosize
                                            name={field.name}
                                            value={vehicleAndSoftCreditData && vehicleAndSoftCreditData[field.name]}
                                            placeholder=" "
                                            label={field.label}
                                            onChange={e => handleInputChange(field.name, field.type, e, vehicleAndSoftCreditData?.financier_id)}
                                            format={field.ApplyNumberformat ? field.format : ""}
                                            required={field.required}
                                            readOnly={freezeCreditAdviceReceived || isNeedsToDisable(field?.name, CREDIT_ADVICE_RECEIVED, vehicleAndSoftCreditDataExisted?.[field?.name]) || field.readOnly || form_read_only} />
                                        <label data-label={field.label} className="form-label"></label>
                                    </div>
                                </fieldset>
                            ) : null

                ))}
            </div>

            <div className="lead-form-heading">
                {vehicleAndSoftCreditData?.docMaster?.length ? ( <h3><b>Documents Upload</b></h3>) : null}
            </div>
            {DocumentUploadHandler(vehicleAndSoftCreditData?.docMaster, form_read_only, markAsFreezed, handleFileChange, vehicleAndSoftCreditData)}
            <br></br>

            <div className="btn-save-remarks">
                {isValidDateSubmit ? <span className="span-disabled">Save</span> : <button type="submit" className="btn-primary" disabled={isValidDateSubmit}>Save</button>}
            </div>

        </Formsy>
    </div>;
};

function DocumentUploadHandler(vehicleAndSoftCreditDocuments, form_read_only, markAsFreezed, handleFileChange, vehicleAndSoftCreditData) {
    return <div className="acco-doc-list">
        <ul>
            {vehicleAndSoftCreditDocuments?.map((fields) => (
                <li>
                    <div className='doc-count-txt'>
                        {fields.lead_doc_count === fields.max_upload ? <span className="stepprogress"><i className="sprite ic-check"></i></span> : ""}
                        {fields.doclang && fields.doclang.name}{fields.is_required === "1" ? '*' : ''}
                        <span className="lead-doc-count">{fields.lead_doc_count || 0} / {fields.max_upload}</span>
                    </div>

                    <div className="more-file-upload doc-upload-btn">
                        {fields.lead_doc_count === fields.max_upload || form_read_only || markAsFreezed ?
                            <button aria-label="disabled btn" type="button" className="btn-line" disabled={true}>
                                <i className='ic-upload'></i> Upload
                            </button> :
                            <>
                                <input aria-label="image upload" type="file" name="" accept=".pdf,image/*" disabled={fields.lead_doc_count === fields.max_upload} onChange={e => handleFileChange(e, fields.id, fields.parent_id, fields.max_upload, fields.lead_doc_count, vehicleAndSoftCreditData?.financier_id)} required={fields.is_required === "1" && !(fields.lead_doc_count >= fields.min_upload)} />
                                <button aria-label="btn image upload" type="button" className="btn-line">
                                    <i className='ic-upload'></i> Upload
                                </button>
                            </>}
                    </div>

                </li>
            ))}
        </ul>
    </div>;
};

